export enum HoVLandingPageEvent {
  LandingPageView = 'user.view_landingpage_house_of_vinted',
  IntroductionCtaClick = 'user.landingpage_hov_introduction_click_cta',
  BrandnewCtaClick = 'user.landingpage_hov_brandnew_click_cta',
  ClosetCtaClick = 'user.landingpage_hov_closet_click_cta',
  ClosetProductCardCtaClick = 'user.landingpage_hov_closet_click_product_card',
  BottomCtaClick = 'user.landingpage_hov_bottom_click_cta',
}

export const hoVLandingPagePopulateParams = [
  'seo.og_image',
  'logo_section.logo',
  'introduction.image',
  'introduction.image_2x',
  'brandnew',
  'brandnew.image_1',
  'brandnew.image_2',
  'brandnew.image_3',
  'brandnew.image_1_mobile',
  'brandnew.image_2_mobile',
  'brandnew.image_3_mobile',
  'creators.cards.image',
  'closet.product_list',
  'bottom',
]
